import * as Yup from 'yup'

import { nameValidation } from '../../fields'

export const validationSchema = Yup.object({
  ...nameValidation
})
